import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { withRouter, Link } from 'react-router'

import { observer, inject } from 'mobx-react'
import Partners from './Partners'
import Footer from './Footer'
import Logo from './Logo'
import SearchForm from './SearchForm'
import ItemPreview from './ItemPreview'
import IconSchools from './IconSchools'
import IconSubjects from './IconSubjects'
import IconRegions from './IconRegions'

import StoreShape from '../../../shared/store-proptypes'
import getPath from '../../../shared/utils/getPath'

@withRouter
@inject('stats') @observer
export default class IndexPage extends Component {

  static propTypes = {
    item: StoreShape.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func
    }),
    stats: StoreShape.isRequired
  }

  componentWillMount() {
    const { stats } = this.props

    stats.openById('fake-id')
  }

  @autobind
  handleSubmit(query) {
    const queryString = `?${Object.keys(query)
      .map((key) => `${key}=${JSON.stringify(query[key])}`).join('&')}`
    this.props.router.push(getPath('frontend', 'map', queryString))
  }

  render() {

    const { item, stats } = this.props

    let numPrograms = 'laden...'
    let numGuidedTours = 'laden...'
    let numMuseums = 'vielen'

    if (stats.current && stats.current.programs) {
      numPrograms = stats.current.programs.total
      numGuidedTours = stats.current.guidedTours.total
      numMuseums = stats.current.museums.total
    }

    const itemsCount = 3 * 6

    /* eslint-disable max-len */
    return (
      <div className="index-page">

        <div className="row">

          <section className="col-xs-3 hidden-xs hidden-sm">
            <ItemPreview
              item={item}
              slice={[0, itemsCount]}
            />
          </section>

          <section className="index-info col-md-6 col-xs-12">

            <div className="logo text-center">
              <Logo />
            </div>

            <p className="lead text-center">
              MUSbi - der direkte Weg zu qualitativ wertvollen museumspädagogischen
              {' '}
              <span className="grp">
                Programmen&nbsp;
                <small>
                  (
                  {numPrograms}
                  )
                </small>
              </span>
              {' '}
              und
              {' '}
              <span className="grp">
                Themenführungen&nbsp;
                <small>
                  (
                  {numGuidedTours}
                  )
                </small>
              </span>
              {' '}
              in
              {' '}
              <strong className="grp">
                {numMuseums}
&nbsp;Museen
              </strong>
              {' '}
              in Oberfranken, Unterfranken, Niederbayern und der Oberpfalz.
            </p>

            <p className="text-center">
              Sämtliche Angebote wurden überprüft. Die KulturServiceStelle des Bezirks Oberfranken stellt damit sicher, dass Inhalte und pädagogische Methoden eng an die bayerischen Lehrpläne angelehnt sind.
            </p>

            <SearchForm onSubmit={this.handleSubmit} />

            <div className="filter-icons text-center">
              <Link to={getPath('frontend', 'map', '?filter=schools')}>
                <IconSchools className="index-icon" />
              </Link>

              <Link to={getPath('frontend', 'map', '?filter=subjects')}>
                <IconSubjects className="index-icon" />
              </Link>

              <Link to={getPath('frontend', 'map', '?filter=regions')}>
                <IconRegions className="index-icon" />
              </Link>
            </div>

          </section>

          <section className="col-xs-3 hidden-xs hidden-sm">
            <ItemPreview
              item={item}
              slice={[itemsCount, itemsCount + itemsCount]}
            />
          </section>

        </div>

        <Partners />

        <Footer />

      </div>
    )
    /* eslint-enable max-len */
  }

}



// WEBPACK FOOTER //
// ./src/frontend/base/components/IndexPage.js